import React from 'react';
import styled from 'styled-components';
import {LoadingScreen} from './loading-screen';

const Container = styled.div`
    display: flex;
    height: 100vh;
`;

export function LoadingPage() {
    return (
        <Container>
            <LoadingScreen/>
        </Container>
    );
}